import React from 'react';
import { Modal, Typography, Form, Input } from '@crisellevaldez/speculo-ui';
import { Organization } from '../../../types/organization.types';
import { Database, DollarSign } from 'lucide-react';

interface SubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedOrg?: Organization;
  onSuccess?: () => void;
}

export const SubscriptionModal: React.FC<SubscriptionModalProps> = ({
  isOpen,
  onClose,
  selectedOrg,
}) => {
  // Get database_size from root org document
  const databaseSize = (selectedOrg?.database_size as number) || 0;
  // Get monthly_price from subscription
  const monthlyPrice = selectedOrg?.subscription?.monthly_price || 0;
  // Get subscription name
  const subscriptionName = selectedOrg?.subscription?.name || '';

  // Determine display value for subscription
  const subscriptionDisplay =
    monthlyPrice > 0 ? `$${monthlyPrice.toLocaleString()}/mo` : subscriptionName || 'Not set';

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <Modal.Header>
        <Typography variant="h3">Subscription Details</Typography>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-6">
          <Form.Control>
            <Form.Label className="flex items-center gap-2">
              <DollarSign className="h-4 w-4" />
              {monthlyPrice > 0 ? 'Monthly Price' : 'Subscription'}
            </Form.Label>
            <Input value={subscriptionDisplay} disabled className="bg-gray-50" />
            <Form.HelperText>
              {monthlyPrice > 0
                ? 'Subscription price per month (read-only)'
                : 'Subscription plan (read-only)'}
            </Form.HelperText>
          </Form.Control>
          <Form.Control>
            <Form.Label className="flex items-center gap-2">
              <Database className="h-4 w-4" />
              Database Size
            </Form.Label>
            <Input value={databaseSize.toLocaleString()} disabled className="bg-gray-50" />
            <Form.HelperText>Total contacts in database (read-only)</Form.HelperText>
          </Form.Control>
        </div>
      </Modal.Body>
    </Modal>
  );
};
